module.exports = __webpack_public_path__ + "img/TwitterPurple.c54b0816.svg";